export default {
  methods: {
    baseUrl(relativeUrl) {
      return `${this.$config.assetPath}${relativeUrl}`
    }
  }
}